import React from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import styled from 'styled-components';
import Clearfix from 'components/elements/clearfix';
import {
  Card,
  Elevation,
  Spinner,
  Intent,
  Classes,
  Tooltip,
  Dialog,
  Alert
} from '@blueprintjs/core';

import { Icon } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import { COLOR, DATE_FORMAT, DEFAULT_NULL_VALUE, AGGREGATORS } from 'config';
import { getAll, exportDataWithIds } from 'api/facilityEnviProtectFeeApi';
import { getAll as getAllLookup } from 'api/lookuplistitemApi';

import PivotTableUI from 'react-pivottable/PivotTableUI';
import 'react-pivottable/pivottable.css';
// import TableRenderers from 'react-pivottable/TableRenderers';
// import Plot from 'react-plotly.js';
// import createPlotlyRenderers from 'react-pivottable/PlotlyRenderers';
import { DateInput } from '@blueprintjs/datetime';
import { Row } from 'reactstrap';
import { createForm } from 'rc-form';
import Jquery from 'jquery';
import BaseDataTableContainer from 'containers/BaseContainer/BaseDataTableContainer';
import slug from 'constants/slug';
// create Plotly renderers via dependency injection
// const PlotlyRenderers = createPlotlyRenderers(Plot);

const SpinnerContainer = styled.div`
  margin: 100px auto;
  text-align: center;
`;

const NameContainer = styled.div`
  color: ${COLOR.SECOND_COLOR};
  text-decoration: underline;
`;

const copyTable = () => {
  let props = [
    'background-color',
    'border',
    'font-size',
    'padding',
    'text-align',
    'color',
    'vertical-align',
    'font-weight'
  ];
  appyStyle(Jquery('.pvtAxisLabel'), props);
  appyStyle(Jquery('.pvtRowLabel'), props);
  appyStyle(Jquery('.pvtColLabel'), props);
  appyStyle(Jquery('.pvtVal'), props);
  appyStyle(Jquery('.pvtTotal'), props);
  appyStyle(Jquery('.pvtGrandTotal'), props);
  appyStyle(Jquery('.pvtTotalLabel'), props);
  appyStyle(Jquery('.pvtTable'), props);
  // if (Jquery('.pvtTable th').length > 0)
  //   appyStyle(Jquery('.pvtTable th'), props);
  // copy( document.getElementsByClassName('pvtOutput')[0].outerHTML.toString())

  // this.copyStringToClipboard(
  //   document.getElementsByClassName('pvtOutput')[0].outerHTML
  // );

  let htmlString = document.getElementsByClassName('pvtOutput')[0].outerHTML;
  exportToExcel(htmlString, 'PhiBaoVeMoiTruongData');
};

const appyStyle = (target, props = []) => {
  for (var i = 0; i < props.length; i++) {
    let tamp = target.css(props[i]);
    target.css(props[i], tamp);
  }
};

export default class BCTKHoSoMoiTruongPanel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ...props,
      isOpenExport: false,
      isLoaded: false,
      dataSource: [],
      data: [],
      filter: {},
      lookupItemObj: {},
      copyData: ''
    };
  }

  columns = [
    {
      dataField: 'FacilityNameFull',
      text: 'Tên cơ sở/dự án',
      formatter: (cell, row) => {
        return (
          <Link
            target='_blank'
            to={slug.ENVI_PROTECT_FEE.VIEW_WITH_ID + row._id}
          >
            <NameContainer>{cell}</NameContainer>
          </Link>
        );
      }
    },
    {
      dataField: 'industrialArea',
      text: '	KCN/CCN',
    },
    {
      dataField: 'district',
      text: 'Quận/Huyện',
    },
    {
      dataField: 'sector',
      text: 'Ngành/Nghề',
    },
    {
      dataField: 'IncurredAddress',
      text: 'Địa chỉ phát sinh nước thải',
    },
    {
      dataField: 'SubjectOfCharge',
      text: 'Thuộc đối tượng thu phí',
    },
  ];

  async componentDidMount() {
    const lookupItemRes = await getAllLookup();

    const res = await getAll();
    if (res.success) {
      const dataSource = _.clone(res.data);
      const lookupItemObj = _.keyBy(lookupItemRes.data, '_id');
      for (var i = 0; i < res.data.length; i++) {
        res.data[i].district = _.result(res.data[i], 'facility.district');
        res.data[i].Commune = _.result(res.data[i], 'facility.Commune');
        res.data[i].sector = _.result(res.data[i], 'facility.sector');
        res.data[i].authority = _.result(res.data[i], 'facility.authority');
        res.data[i].industrialArea = _.result(
          res.data[i],
          'facility.industrialArea'
        );
        res.data[i].ReceviedSource_4 = _.result(
          res.data[i],
          'facility.ReceviedSource_4.name'
        );
        res.data[i].ReceviedSource_3 = _.result(
          res.data[i],
          'facility.ReceviedSource_3.name'
        );

        if (res.data[i].district && lookupItemObj[res.data[i].district]){
          res.data[i]['10.Quận/Huyện'] = lookupItemObj[res.data[i].district].Name;
          res.data[i]['district'] = lookupItemObj[res.data[i].district].Name;
        } else res.data[i]['10.Quận/Huyện'] = DEFAULT_NULL_VALUE;

        if (res.data[i].Commune)
          res.data[i]['11.Phường/Xã'] = res.data[i].Commune;
        else res.data[i]['11.Phường/Xã'] = DEFAULT_NULL_VALUE;
        if (res.data[i].sector && lookupItemObj[res.data[i].sector]){
          res.data[i]['2.Ngành/Nghề'] = lookupItemObj[res.data[i].sector].Name;
          res.data[i]['sector'] = lookupItemObj[res.data[i].sector].Name;
        } else res.data[i]['2.Ngành/Nghề'] = DEFAULT_NULL_VALUE;

        if (res.data[i].authority && lookupItemObj[res.data[i].authority])
          res.data[i]['9.Thẩm quyền quản lý'] =
            lookupItemObj[res.data[i].authority].Name;
        else res.data[i]['9.Thẩm quyền quản lý'] = DEFAULT_NULL_VALUE;

        if ( res.data[i].industrialArea && lookupItemObj[res.data[i].industrialArea]){
          res.data[i]['1.KCN/CCN'] = lookupItemObj[res.data[i].industrialArea].Name;
          res.data[i]['industrialArea'] = lookupItemObj[res.data[i].industrialArea].Name;
        } else res.data[i]['1.KCN/CCN'] = DEFAULT_NULL_VALUE;

        res.data[i]['5.Thuộc đối tượng thu phí'] = res.data[i].SubjectOfCharge;
        res.data[i]['6.Thẩm quyền thu phí BVMT'] = res.data[i].AuthorityBVMT;
        res.data[i]['3.Năm tính phí'] = res.data[i].YearOfCharge;
        res.data[i]['4.Quý tính phí'] = res.data[i].QuaterOfCharge;
        if(res.data[i].PaymentStatus)
          res.data[i]['7.Tình trạng nộp'] = res.data[i].PaymentStatus;
        else res.data[i]['7.Tình trạng nộp'] = DEFAULT_NULL_VALUE;
        res.data[i]['8.Công nợ'] = res.data[i].Payment;
        if (res.data[i].ReceviedSource_4)
          res.data[i]['12.Vùng tiếp nhận 4'] = res.data[i].ReceviedSource_4;
        else res.data[i]['12.Vùng tiếp nhận 4'] = DEFAULT_NULL_VALUE;

        if (res.data[i].ReceviedSource_3)
          res.data[i]['13.Vùng tiếp nhận 3'] = res.data[i].ReceviedSource_3;
        else res.data[i]['13.Vùng tiếp nhận 3'] = DEFAULT_NULL_VALUE;


        // res.data[i] = _.pick(res.data[i], ['10.Quận/Huyện', '2.Ngành/Nghề','9.Thẩm quyền quản lý'])
        res.data[i] = _.omit(res.data[i], [
          // 'district',
          'Commune',
          'ReceviedSource_3',
          'ReceviedSource_4',
          // 'sector',
          // '_id',
          'authority',
          'Latitude',
          'Longitude',
          'FacilityCode',
          'FacilityNameFull',
          'province',
          // 'industrialArea',
          'AddedOn',
          // 'facility',
          'emissionType',
          'IssueDate',
          'YearOfCharge',
          'QuaterOfCharge',
          'PaymentStatus',
          'SubmitDate',
          'SubmitTime',
          'AuthorityBVMT',
          // 'SubjectOfCharge',
          'Payment'
        ]);
      }

      this.setState({
        data: res.data,
        isLoaded: true,
        dataSource,
        lookupItemObj
      });
    }
  }

  convertToDataTable() {
    let dataSource = _.clone(this.state.dataSource);
    dataSource = dataSource.filter(item => {
      if (!item.AddedOn) return true;
      const time = moment(item.AddedOn);
      return (
        time >= this.state.filter.fromDate && time <= this.state.filter.toDate
      );
    });

    this.setState({
      data: dataSource,
      isLoaded: true
    });
  }

  render() {
    return (
      <div style={{ width: '100%' }}>
        <Clearfix height={8} />
        <Card interactive={true} elevation={Elevation.TWO}>
          <h5>
            <a
              href=' '
              style={{
                display: 'flex',
                alignItems: 'center',
                color: COLOR.SUCCESS
              }}
            >
              <Icon icon={IconNames.LIST} />
              <Clearfix width={8} />
              Báo Cáo Thống Kê Phí bảo vệ môi trường
            </a>
          </h5>
          <SearchContainer
           isOpenExport={this.state.isOpenExport}
           onCloseModal={() => this.setState({ isOpenExport: false })}
            handlClick={val => {
              this.setState(
                {
                  filter: val
                },
                () => {
                  this.convertToDataTable();
                }
              );
            }}
          />
          <Clearfix height={8} />

          {/* <PivotTableUI 
         unusedOrientationCutoff={900}
                data={this.state.data}
                onChange={s => this.setState(s)}
                renderers={Object.assign({}, TableRenderers, PlotlyRenderers)}
                {...this.state}
            /> */}
          {this.state.isLoaded && (
            <PivotTableUI
              tableOptions={{
                clickCallback: (e, value, filters, pivotData) => {
                  var names = [];
                  for(let props in filters){
                    if(filters[props] === undefined) delete filters[props]
                  }
                  pivotData.forEachMatchingRecord(filters, function(record) {
                    names.push({
                      _id: record._id,
                      FacilityNameFull: _.result(
                        record,
                        'facility.FacilityNameFull',
                        DEFAULT_NULL_VALUE
                      ),
                      industrialArea: record.industrialArea,
                      district: record.district,
                      sector: record.sector,
                      IncurredAddress: record.IncurredAddress,
                      SubjectOfCharge: record.SubjectOfCharge,
                    });
                  });
                  // alert(names.join('\n'));
                  this.setState({
                    dataList: names,
                    isOpenModal: true
                  });
                }
              }}
              hiddenFromDragDrop={['8.Công nợ', '_id', 'facility', 'SubjectOfCharge', 'district', 'industrialArea', 'sector', 'AddedOn', 'Commune', 'ReceviedSource_3', 'ReceviedSource_4', 'authority', 'IncurredAddress', 'Indebtedness']}
              hiddenFromAggregators={[
                '_id',
                '2.Ngành/Nghề',
                '10.Quận/Huyện',
                '9.Thẩm quyền quản lý',
                '1.KCN/CCN',
                'facility',
                '5.Thuộc đối tượng thu phí',
                '3.Năm tính phí',
                '4.Quý tính phí',
                '7.Tình trạng nộp',
                '6.Thẩm quyền thu phí BVMT',
                'SubjectOfCharge',
                'district',
                'sector',
                'industrialArea',
                '11.Phường/Xã',
                '12.Vùng tiếp nhận 4',
                '13.Vùng tiếp nhận 3',
                'IncurredAddress',
                'AddedOn', 'Commune', 'ReceviedSource_3', 'ReceviedSource_4', 'authority', 'Indebtedness'
              ]}
              unusedOrientationCutoff={900}
              data={this.state.data}
              onChange={s => this.setState(s)}
              {...this.state}
              aggregators={this.state.aggregators}
              ref={pivotComp => {
                if (
                  _.result(pivotComp, 'props.aggregators') &&
                  !this.state.aggregators
                ) {
                  let aggregators = _.result(pivotComp, 'props.aggregators');

                  this.setState({
                    aggregators: _.pick(aggregators, AGGREGATORS)
                  });
                }
              }}
            />
          )}

          {!this.state.isLoaded && (
            <SpinnerContainer>
              <Spinner intent={Intent.PRIMARY} size={200} />
            </SpinnerContainer>
          )}
        </Card>

        <Clearfix height={8} />
        <Dialog
          style={{
            width: '80vw'
          }}
          icon='info-sign'
          title={
            <div>
              <span style={{ marginRight: 8 }}>Thông tin</span>
              <Icon
                icon={IconNames.EXPORT}
                iconSize={Icon.SIZE_LARGE}
                className='pointer'
                intent={Intent.SUCCESS}
                onClick={async () => {
                  this.setState({ isOpenExport: true });
                  let res = await exportDataWithIds({
                    _id: this.state.dataList.map((item) => item._id),
                  });
                  // console.log(res);
                  let dataBuff = toArrayBuffer(res.buffer.data);
                  let blob = new Blob([dataBuff], {
                    type:
                      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                  });
                  getFile(blob, res.fileName);
                }}
              />
            </div>
          }
          isOpen={this.state.isOpenModal}
          onClose={() => {
            this.setState({
              isOpenModal: false
            });
          }}
          className={Classes.OVERLAY_SCROLL_CONTAINER}
          usePortal
          canOutsideClickClose
          canEscapeKeyClose
          hasBackdrop
        >
          <div
            style={{ whiteSpace: 'pre-line' }}
            className={`${Classes.DIALOG_BODY}`}
          >
            <BaseDataTableContainer
              dataList={this.state.dataList}
              columns={this.columns}
            />
          </div>
        </Dialog>

        <Clearfix height={8} />
      </div>
    );
  }
}

@createForm()
class SearchContainer extends React.Component {
  getSearch() {
    const { getFieldsValue } = this.props.form;
    let val = getFieldsValue(['fromDate', 'toDate']);
    if (!val.fromDate) val.fromDate = moment(1970);
    if (!val.toDate) val.toDate = moment();
    return val;
  }
  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <div>
        <Row>
          <Clearfix width={16} />
          <div style={{ display: 'flex', alignItems: 'center', width: 300 }}>
            <span>Từ ngày</span>
            <Clearfix width={8} />
            <div style={{ flex: 1 }}>
              {getFieldDecorator(
                'fromDate',
                {}
              )(
                <DateInput
                  popoverProps={{
                    targetClassName: 'el-fill'
                  }}
                  formatDate={date => moment(date).format(DATE_FORMAT)}
                  parseDate={str => moment(str).toDate()}
                />
              )}
            </div>
          </div>
          <Clearfix width={16} />
          <div style={{ display: 'flex', alignItems: 'center', width: 330 }}>
            <span>Đến ngày</span>
            <Clearfix width={8} />
            <div style={{ flex: 1 }}>
              {getFieldDecorator(
                'toDate',
                {}
              )(
                <DateInput
                  popoverProps={{
                    targetClassName: 'el-fill'
                  }}
                  formatDate={date => moment(date).format(DATE_FORMAT)}
                  parseDate={str => moment(str).toDate()}
                />
              )}
            </div>
            <Clearfix width={8} />
            <Tooltip content='Lọc theo Ngày tạo'>
              <Icon
                icon={IconNames.SEARCH}
                iconSize={Icon.SIZE_LARGE}
                intent={Intent.SUCCESS}
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  let val = this.getSearch();
                  if (this.props.handlClick) this.props.handlClick(val);
                }}
              />
            </Tooltip>
            <Clearfix width={8} />
            <Tooltip content='Xuất file Excel'>
              <Icon
                icon={IconNames.EXPORT}
                iconSize={Icon.SIZE_LARGE}
                className='pointer'
                intent={Intent.SUCCESS}
                onClick={copyTable}
              />
            </Tooltip>
          </div>
        </Row>
        <Alert
          confirmButtonText='Cancel'
          isOpen={this.props.isOpenExport}
          onClose={() => {
            this.props.onCloseModal();
          }}
        >
          <div id='downloadlink'>Export.....</div>
        </Alert>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/ReportContainer/FacilityEnviProtectFeePanel/index.js